import { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Box, Stack } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useStyles } from '../styles/sectionStyles';
import { SectionHeader, TaskCard } from '.';
import { getMyTaskFilteredTask } from '../../../services/taskService';

const rowsPerPage = 5;

const Section = ({
  section,
  setLoading,
  runningTask,
  setRunningTask,
  handleTaskClick,
  handleAddTaskClick,
  allTask,
}) => {
  const accountData = useSelector((state) => state?.login?.user || null);
  const classes = useStyles({ isOver: false });
  const [taskList, setTaskList] = useState(allTask);
  const [taskCount, setTaskCount] = useState(0);
  const [pageState, setPageState] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [refetcher, setRefetcher] = useState(false);

  const userId = accountData?.id;

  const setNextPage = () => {
    setPageState((prev) => prev + rowsPerPage);
  };

  useEffect(() => {
    setTaskCount(allTask?.filter((item) => item?.projectId === section?.id).length);
  }, [allTask, section?.id]);

  // const refetchTask = useCallback(() => {
  //   setTaskList([]);
  //   setPageState(0);
  //   setHasMore(true);
  //   setRefetcher((prev) => !prev);
  // }, []);

  // useEffect(() => {
  //   const fetchTaskData = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await getMyTaskFilteredTask({
  //         start: pageState,
  //         pageSize: rowsPerPage,
  //         projectId: section?.id,
  //       });

  //       const mytaskList = response?.data?.data?.rows;
  //       if (mytaskList.length < rowsPerPage) setHasMore(false);
  //       setTaskList((prev) => [...prev, ...mytaskList]);
  //       setTaskCount(response?.data?.data?.count);
  //     } catch (error) {
  //       const errMsg = error?.response?.data?.message || 'An error occurred while fetching task data';
  //       toast.error(errMsg);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchTaskData();
  // }, [userId, setLoading, pageState, section?.id, refetcher]);

  return (
    <Box className={classes.section}>
      <SectionHeader onAddClick={handleAddTaskClick} section={section} taskCount={taskCount} />
      <Stack spacing={1} className={classes?.taskStack} id={`scrollableDiv-${section?.id}`}>
        {/* <InfiniteScroll
          dataLength={taskList?.length ?? 0}
          next={setNextPage}
          hasMore={hasMore}
          scrollableTarget={`scrollableDiv-${section?.id}`}
          className={classes?.infiniteScroll}
        > */}
        {taskList?.map((task) => {
          if (task?.projectId !== section?.id) return null;

          return (
            <TaskCard
              key={task?.id}
              task={task}
              project={section}
              onClick={handleTaskClick(task, section)} // section is project here
              setLoading={setLoading}
              runningTask={runningTask}
              // refetchTask={refetchTask}
              setTaskList={setTaskList}
              setRunningTask={setRunningTask}
              style={{ margin: '0px auto 10px auto' }}
            />
          );
        })}
        {/* </InfiniteScroll> */}
        {/* <Button color="inherit" className={classes?.addTaskBtn} onClick={handleAddTaskClick} startIcon={<Add />}>
          Add Task
        </Button> */}
      </Stack>
      {/* <Drawer
        PaperProps={{ sx: { width: '55%' } }}
        anchor="right"
        open={!isStakeholder() && Boolean(action)}
        onClose={handleClose}
      >
        <Box p={2}>
          <ProjectAddTask
            selectedTask={selected}
            open={openModal}
            project={selectedProject}
            close={handleClose}
            action={action}
            onSubmit={refetchTask}
          />
        </Box>
      </Drawer> */}
    </Box>
  );
};

Section.propTypes = {
  section: PropTypes.object,
  setLoading: PropTypes.func,
  runningTask: PropTypes.object,
  setRunningTask: PropTypes.func,
  handleTaskClick: PropTypes.func,
  handleAddTaskClick: PropTypes.func,
  // ProjectAddTask Props
  // selected: PropTypes.object,
  // openModal: PropTypes.bool,
  // selectedProject: PropTypes.object,
  // handleClose: PropTypes.func,
  // action: PropTypes.string,
};

export default Section;
